export default "__VITE_ASSET__8QnyK9AP__$_?imageSize__"